import {useEffect} from 'react';
import {DefaultMetaTags} from '@common/seo/default-meta-tags';
import {PricingSection} from './components';
import './landing-page.css';

export function PricingPage() {
  // Load fonts
  useEffect(() => {
    const fontsLink = document.createElement('link');
    fontsLink.href =
      'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,600&display=swap';
    fontsLink.rel = 'stylesheet';
    document.head.appendChild(fontsLink);

    return () => {
      fontsLink.remove();
    };
  }, []);

  // Intersection Observer for fade-up animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {threshold: 0.1, rootMargin: '0px 0px -40px 0px'},
    );

    const fadeElements = document.querySelectorAll('.fade-up');
    fadeElements.forEach(el => observer.observe(el));

    return () => {
      fadeElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="landing-page">
      <DefaultMetaTags />
      <div style={{paddingTop: 72}}>
        <PricingSection />
      </div>
    </div>
  );
}
